class StarRating {
  constructor(container) {
    this.starContainer = container.querySelector(".star-rating");
    this.ratingInput = container.querySelector(".hidden-input");
    this.maxStars = 5;
    this.createStars();
    this.setRating(this.ratingInput.value);
  }

  createStars() {
    for (let i = 1; i <= this.maxStars; i++) {
      const star = document.createElement("span");
      star.setAttribute("data-value", i);
      star.setAttribute("tabindex", 0);
      star.innerHTML = this.getStarSVG(false);
      star.addEventListener("click", () => this.setRating(i));
      star.addEventListener("mouseover", () => this.hoverStars(i));
      star.addEventListener("mouseout", () => this.hoverStars(0));
      star.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          this.setRating(i);
        }
      });
      this.starContainer.appendChild(star);
    }
  }

  setRating(rating) {
    this.ratingInput.value = rating;
    const stars = this.starContainer.querySelectorAll("span");
    stars.forEach((star, index) => {
      star.innerHTML = this.getStarSVG(index < rating);
      star.classList.toggle("active", index < rating);
    });
  }

  hoverStars(rating) {
    const stars = this.starContainer.querySelectorAll("span");
    stars.forEach((star, index) => {
      star.classList.toggle("hover", index < rating);
    });
  }

  getStarSVG(selected) {
    return selected
      ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.5 21.4" class="pointer-events-none"><path fill="currentColor" d="M22.5 8.2 14.7 7l-3.4-7-3.5 7L0 8.2l5.6 5.5-1.3 7.7 7-3.7 6.9 3.7-1.3-7.7 5.6-5.5Z"></path></svg>'
      : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.8 25.5" class="pointer-events-none"><path fill="none" stroke="currentColor" stroke-width="2" d="M24.6 10.4 17 9.3l-3.5-7-3.5 7-7.8 1.1L7.8 16l-1.4 7.8 7-3.7 7 3.7-1.4-7.8 5.6-5.5Z"></path></svg>';
  }
}

document
  .querySelectorAll(".js-rating-container")
  .forEach((container) => new StarRating(container));
